<template>
    <div>
        <ModalHeader title="설정"/>
        <div style="padding:20px;">
            <ProgressButton
                    buttonText="회원탈퇴"
                    :showProgress="isSubmitting"
                    @click="handleSubmit"
                    style="margin-top:0px;"
            />
        </div>
    </div>
</template>

<script>
    import ModalHeader from "../common/ModalHeader";
    import ProgressButton from "../common/ProgressButton";
    export default {
        name: "Setting",
        components: {ProgressButton, ModalHeader},
        data(){
            return {

            }
        },
        methods : {
            async handleSubmit(){
                if(!confirm('정말로 탈퇴하시겠습니까?\n탈퇴 후 복구는 불가능합니다.')){
                    return;
                }


            }
        }
    }
</script>

<style scoped>

</style>